const Resources = {

    table_headers: [
        { 
            text: 'Daily Assignments',
            align: 'start',
            value: 'daily_assignments'
        },
        {
            text: 'Room',
            value: 'room'
        },
        {
            text: 'Bed code',
            value: 'name'
        },
    ],
    
    breadcrumb:[
        {
            name: 'Home',
            href: '/',
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: 'Census',
            href: '#',
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: 'Vacant Beds',
            href: '/census-vacant-beds',
            arrow: "",
        },
    ],
    
    excel_file_headers: {
        'Code': 'code',
    },

    empty_format_data: [
        {
            code: '',
        },
    ],

    supervisor_report_table_headers: [
        {
            text: 'Description',
            align: 'start',
            value: 'assignment_name',
            report_value: 'assignment_name',
            show: true,
        },
        {
            text: 'Assigned Employee',
            value: 'associate',
            report_value: 'associate',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Available Time',
            value: 'available_time_calc',
            report_value: 'available_time_calc',
            show: true,
        },
        {
            text: 'Discharge Capability',
            value: 'discharge_capability',
            report_value: 'discharge_capability',
            show: true,
        },
    ],

    beds_report_table_headers: [
        {
            text: 'Daily Assignments',
            align: 'start',
            value: 'daily_assignments',
            report_value: 'daily_assignments',
            show: true,
        },
        {
            text: 'Room',
            align: 'start',
            value: 'room',
            report_value: 'room',
            show: true,
        },
        {
            text: 'Bed Code',
            value: 'bed_code',
            report_value: 'bed_code',
            sort_type: 'text',
            show: true,
        },
    ],

    supervisor_report_totals: [
        {
            associate:
            {
                show: true,
                text: 'Totals',
                value: 'Totals:',
            },

            available_time_calc:
            {
                show: true,
                text: 'Available time',
                value: 0,
            }, 

            discharge_capability:
            {
                show: true,
                text: 'Discharge Capability',
                value: 0,
            }
            
        },
        {
            associate:
            {
                show: true,
                text: 'FTEs',
                value: 'FTEs:',
            }, 

            available_time_calc:
            {
                show: true,
                text: 'Available time',
                value: 0,
            }, 
        }
    ],

    helps: [
        {
            label: '¿How to enter the Daily Census?', 
            instruction: `https://scribehow.com/embed/How_to_Enter_the_Daily_Census__HK3M5b4uT1KlNloLw9SSTg?as=scrollable`
        },
    ]

}

export default Resources;